import React from 'react';
import { getConfig } from 'fitbeat.react-native-components';
import { FullWidthLayout } from './Layouts/FullWidthLayout';
const isMobile = window.innerWidth <= 550;

export const FaqIFrame = () => (
    <iframe
        // desktop is different from mobile only in opening up the first page
        src={isMobile ? getConfig().pages.faq : getConfig().pages.desktopFaq}
        frameborder="0"
        style={{ "overflow": "hidden", "height": "calc(100vh - 56px)", "width": "100%" }}
        height="100%"
        width="100%"
    />
)

export const FaqScreenContainer = (props) => (
    <FullWidthLayout {...props}>
        <FaqIFrame />
    </FullWidthLayout>
);
